import request from './request'

/**
 * 获取微信JS-SDK配置信息
 * @param {String} url 当前页面URL，不包含#及其后面部分
 * @returns {Promise} 返回包含签名等信息的Promise
 */
export function getWechatJsConfig(url) {
  return request({
    url: '/api/wechat/js-config',
    method: 'get',
    params: {
      url: url
    }
  })
}

/**
 * 获取微信分享参数
 * @param {String} type 分享类型，如product, article等
 * @param {String} id 分享内容ID
 * @returns {Promise} 返回包含分享标题、描述、图片等信息的Promise
 */
export function getShareParams(type, id) {
  return request({
    url: '/api/wechat/share-params',
    method: 'get',
    params: {
      type,
      id
    }
  })
}

/**
 * 记录分享事件
 * @param {Object} data 分享数据
 * @returns {Promise}
 */
export function recordShareEvent(data) {
  return request({
    url: '/api/wechat/record-share',
    method: 'post',
    data
  })
}

export function wechatLogin(code, state) {
  const resolvedState = state || localStorage.getItem('wechat_login_state') || ''
  return request({
    url: '/api/auth/wechat/h5',
    method: 'post',
    data: {
      code,
      state: resolvedState,
      platform: 'officialAccount'
    }
  })
}

export default {
  getWechatJsConfig,
  getShareParams,
  recordShareEvent,
  wechatLogin
}
